import { useTranslation } from 'react-i18next';
import { Construction } from 'lucide-react';
import { useTheme } from 'components/core/theme-provider';

/**
 * Coming Soon Tab Component
 * 
 * A placeholder component displayed for settings tabs that are not yet implemented.
 * Provides a consistent "coming soon" message with proper theming.
 * 
 * @param tabId - The ID of the tab (for future customization if needed)
 * @returns A coming soon placeholder component
 */

interface ComingSoonTabProps {
    tabId: string;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const ComingSoonTab = ({ tabId }: ComingSoonTabProps) => {
    const { t } = useTranslation();
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { theme } = useTheme();

    return (
        <div className="flex flex-col items-center justify-center text-center h-full">
            <div className="max-w-md mx-auto">
                <Construction className="h-16 w-16 text-muted-foreground mx-auto mb-4" />
                <h3 className="text-xl font-semibold text-foreground mb-2">
                    {t('COMING_SOON') || 'Coming Soon'}
                </h3>
                <p className="text-muted-foreground">
                    {t('COMING_SOON_DESCRIPTION') ||
                        'This feature is currently under development and will be available in a future update.'}
                </p>
            </div>
        </div>
    );
};
